/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Hosted Set-Password URL for the change-password flow
 */
import { ValidateUtils } from 'app/shared/utils';

export class PasswordResetUrl { 
    /**
     * Hosted Set-Password URL to redirect the browser to; the user enters the code emailed to them.
     */
    readonly resetUrl: string;

    constructor(item?: Partial<PasswordResetUrl>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            resetUrl: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.resetUrl : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: PasswordResetUrl.isValid,
        };
    }

    static isValid(obj: PasswordResetUrl): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = PasswordResetUrl.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.resetUrl.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

